module.exports = __webpack_public_path__ + "static/media/Connect.7e90b9a2.svg";